import { createContext, useContext, useMemo } from 'react';
import { DEFAULT_PROGRAM, makeProgram, solaPogoji } from './lib/program.js';
import { PERUT_LOGO, PERUT_SOLA_ID } from './config.js';

/*
  Šola, v kateri uporabnik trenutno dela.

  Tečajnik ima natanko eno šolo (profiles.sola_id). Inštruktor je lahko
  član več šol in med njimi preklaplja; platforma (Luka) vidi vse. Vse,
  kar je odvisno od šole — program vaj, pogoji za izpit, logotip, agencija,
  povezave — pride od tod, ne iz konstant.
*/

const PERUT_FALLBACK = {
  id: PERUT_SOLA_ID,
  slug: 'perut',
  ime: 'Perut Paragliding',
  kratko: 'Učilnica',
  drzava: 'SI',
  jezik: 'sl',
  logo_url: PERUT_LOGO,
  status: 'aktivna',
  plan: 'interno',
  nastavitve: {},
};

const SolaContext = createContext({
  sola: PERUT_FALLBACK,
  program: DEFAULT_PROGRAM,
  pogoji: solaPogoji(null),
  vloga: 'tecajnik',
  platforma: false,
});

export function SolaProvider({ sola, programRows, vloga = 'tecajnik', platforma = false, children }) {
  const value = useMemo(() => {
    const s = sola ?? PERUT_FALLBACK;
    return {
      sola: s,
      program: makeProgram(programRows, s.nastavitve?.sklopi),
      /** Vrstice, kot so v bazi (prazno = program še ni shranjen, velja privzeti). */
      programRows: programRows ?? [],
      pogoji: solaPogoji(s),
      vloga,
      platforma,
    };
  }, [sola, programRows, vloga, platforma]);
  return <SolaContext.Provider value={value}>{children}</SolaContext.Provider>;
}

export const useSola = () => useContext(SolaContext);

/** Nastavitve šole z varnimi privzetimi vrednostmi (Perutove). */
export function solaNastavitve(sola) {
  const n = sola?.nastavitve ?? {};
  return {
    agencija: {
      naziv: 'Javna agencija za civilno letalstvo',
      naslov: 'Javna agencija za civilno letalstvo\nKotnikova ulica 19A\nSI-1000 Ljubljana',
      url: 'https://www.caa.si',
      prijavnica_ime: 'FCL.APL-139',
      prijavnica_url: '/obrazci/FCL.APL-139-prijava-na-izpit.docx',
      roki_url:
        'https://www.caa.si/files/www%20-%20FCL/Izpitni%20roki%20za%20teoreti%C4%8Dno%20preverjanje%20znanja.pdf',
      blog_url: 'https://www.perut.net/blog/solanje-5/prijava-na-izpit-5',
      ...(n.agencija ?? {}),
    },
    povezave: {
      vprasanja: sola?.id === PERUT_SOLA_ID || !sola ? 'https://izpitna-vprasanja.netlify.app' : '',
      ucbenik:
        sola?.id === PERUT_SOLA_ID || !sola
          ? 'https://qhzrtpkfayresklpqrdt.supabase.co/storage/v1/object/public/Assets/Ucbenik_jadralnih_padal.pdf'
          : '',
      ...(n.povezave ?? {}),
    },
    prag: Number(n.prag) || 80,
    sklopi: n.sklopi ?? null,
  };
}
